export const preventDoubleClick = (fn, timeout = 5000) => {
  let isClicked = false;

  return (...args) => {
    if (isClicked) {
        alert("Click once! Have patience!")
        return;
    }
    isClicked = true;

    fn(...args);

    setTimeout(() => {
      isClicked = false;
    }, timeout);
  };
};